import { createContext, useContext } from 'react';
import { TableCellContextProps, TableCellProviderProps } from './types';

export const TableCellContext = createContext<TableCellContextProps | null>(
  null
);

export const TableCellProvider = ({
  children,
  cellContextProps
}: TableCellProviderProps): JSX.Element => {
  return (
    <TableCellContext.Provider value={cellContextProps}>
      {children}
    </TableCellContext.Provider>
  );
};

export function useTableCellContext(): TableCellContextProps {
  const context = TableCellContext;
  if (!context) {
    console.error('There is an error with tableCell context');
  }
  return useContext(context) as TableCellContextProps;
}
